function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "food (1)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 435",
  d: "M80.613 49.572a8.54 8.54 0 01-1.112-1.621 28.281 28.281 0 11-.714-6.623l2.563-19.054.058-.428a39.693 39.693 0 00-55.113-5.145v9.167a15.573 15.573 0 01-7.215 13.123v32.09a39.726 39.726 0 0065.31-1.537V52.065a8.516 8.516 0 01-3.777-2.493z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 436",
  d: "M51.205 24.179a23.494 23.494 0 1023.494 23.494 23.521 23.521 0 00-23.494-23.494z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 437",
  d: "M96.148 3.707a3.706 3.706 0 00-7.38-.494l-5.416 40.26a3.706 3.706 0 003.673 4.2H89.2v43.184a3.527 3.527 0 107.055 0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 438",
  d: "M21.485 4.489a2.405 2.405 0 10-4.81 0v13.308h-3.528V4.489a2.405 2.405 0 10-4.81 0v13.308H4.81V4.489a2.405 2.405 0 10-4.81 0v21.7a10.76 10.76 0 007.215 10.143v54.524a3.527 3.527 0 007.055 0V36.332a10.76 10.76 0 007.215-10.145z"
}));

function SvgDisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96.254,
    height: 94.384
  }, props), _ref);
}

export default SvgDisk;